// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var $$String = require("rescript/lib/js/string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Webapi__Dom__Node = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Node.bs.js");
var Webapi__Dom__Text = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Text.bs.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");

function ofNode(_node) {
  while(true) {
    var node = _node;
    var match = Webapi__Dom__Node.nodeType(node);
    if (match >= 3) {
      return Js_exn.raiseError("Expected nodeType = Element | Text");
    }
    switch (match) {
      case /* Element */0 :
          var arg = Webapi__Dom__Element.ofNode(node);
          var element = (function(arg){
            return function (param) {
              return OptionUtils$SmartcutsMacros.getExn(param, arg);
            }
            }(arg))("Expected element for Element node in Selection.Text.ofNode");
          var node$1 = element.firstChild;
          if (node$1 == null) {
            return ;
          }
          if (Webapi__Dom__Node.nodeType(node$1) === /* Text */2) {
            var arg$1 = Webapi__Dom__Text.ofNode(node$1);
            var textNode = (function(arg$1){
              return function (param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
              }
              }(arg$1))("Text.ofNode error: Expected to get TextNode if nodeType == Text");
            return textNode.data;
          }
          if (Webapi__Dom__Node.nodeType(node$1) !== /* Element */0) {
            return ;
          }
          _node = node$1;
          continue ;
      case /* Attribute */1 :
          return Js_exn.raiseError("Expected nodeType = Element | Text");
      case /* Text */2 :
          var arg$2 = Webapi__Dom__Text.ofNode(node);
          return (function(arg$2){
                  return function (param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
                  }
                  }(arg$2))("Expected text for Text node in Selection.Text.ofNode").data;
      
    }
  };
}

var regexWhitespace = /\w/g;

function indexOfFirstNonWhitespaceChar(s) {
  return s.search(regexWhitespace);
}

function indexOfLastNonWhitespaceChar(s) {
  var reversed = StringUtils$SmartcutsMacros.reverse(s);
  var i = reversed.search(regexWhitespace);
  if (i === -1) {
    return i;
  } else {
    return (s.length - 1 | 0) - i | 0;
  }
}

function isWhitespace(character) {
  var re = /^\s$/;
  return re.test(character);
}

function isComma(str) {
  return str === ",";
}

function isPeriod(str) {
  return str === ".";
}

function isBoundaryToken(str) {
  if (isWhitespace(str) || str === ",") {
    return true;
  } else {
    return str === ".";
  }
}

function fromText(text) {
  var characters = Array.from(text);
  var state = Belt_Array.reduceWithIndex(characters, {
        words: [],
        parsing: undefined
      }, (function (state, token, index) {
          var parsing = state.parsing;
          var words = state.words;
          if (isWhitespace(token) || token === "," || token === ".") {
            if (parsing !== undefined) {
              return {
                      words: $$Array.append(words, [parsing]),
                      parsing: undefined
                    };
            } else {
              return state;
            }
          } else if (parsing !== undefined) {
            return {
                    words: words,
                    parsing: [
                      parsing[0],
                      parsing[1] + token
                    ]
                  };
          } else {
            return {
                    words: words,
                    parsing: [
                      index,
                      token
                    ]
                  };
          }
        }));
  var word = state.parsing;
  if (word !== undefined) {
    return $$Array.append(state.words, [word]);
  } else {
    return state.words;
  }
}

function getIndexOfPriorNonBoundaryToken(index, text) {
  var arg = Belt_Array.getIndexBy(Belt_Array.reverse(Array.from(text.slice(0, index))), (function ($$char) {
          return !isBoundaryToken($$char);
        }));
  return index - (function (param) {
              return OptionUtils$SmartcutsMacros.withDefault(param, arg);
            })(0) | 0;
}

function getIndexOfNextNonBoundaryToken(index, text) {
  var arg = Belt_Array.getIndexBy(Array.from(text.slice(index)), (function ($$char) {
          return !isBoundaryToken($$char);
        }));
  return index + (function (param) {
              return OptionUtils$SmartcutsMacros.withDefault(param, arg);
            })(0) | 0;
}

var ParseWords = {
  isWhitespace: isWhitespace,
  isComma: isComma,
  isPeriod: isPeriod,
  isBoundaryToken: isBoundaryToken,
  fromText: fromText,
  getIndexOfPriorNonBoundaryToken: getIndexOfPriorNonBoundaryToken,
  getIndexOfNextNonBoundaryToken: getIndexOfNextNonBoundaryToken
};

var $$Text = {
  ofNode: ofNode,
  regexWhitespace: regexWhitespace,
  indexOfFirstNonWhitespaceChar: indexOfFirstNonWhitespaceChar,
  indexOfLastNonWhitespaceChar: indexOfLastNonWhitespaceChar,
  ParseWords: ParseWords
};

function getPrefixAndSuffixWord(startText, startOffset, endText, endOffset) {
  var textBeforeSelection = startText.slice(0, startOffset);
  var wordsBeforeSelection = fromText(textBeforeSelection);
  var length = wordsBeforeSelection.length;
  var prefixWord;
  if (length !== 0) {
    var match = Caml_array.get(wordsBeforeSelection, length - 1 | 0);
    var sliceFrom = getIndexOfPriorNonBoundaryToken(match[0], textBeforeSelection);
    var textUtilStartOffset = startText.slice(sliceFrom, startOffset);
    prefixWord = [
      sliceFrom,
      textUtilStartOffset
    ];
  } else {
    prefixWord = undefined;
  }
  var endTextLength = endText.length;
  var textAfterSelection = endText.slice(endOffset);
  var wordsAfterSelection = endOffset === endTextLength ? [] : fromText(textAfterSelection);
  var match$1 = Belt_Array.get(wordsAfterSelection, 0);
  var suffixWord;
  if (match$1 !== undefined) {
    var wordEnds = match$1[0] + match$1[1].length | 0;
    var substringLength = getIndexOfNextNonBoundaryToken(wordEnds, textAfterSelection);
    var textAfterEndOffset = $$String.sub(endText, endOffset, substringLength);
    suffixWord = [
      endOffset,
      textAfterEndOffset
    ];
  } else {
    suffixWord = undefined;
  }
  return [
          prefixWord,
          suffixWord
        ];
}

var SemanticsPrefixSuffix = {
  getPrefixAndSuffixWord: getPrefixAndSuffixWord
};

function indexOfWordAtOffset(offset, words) {
  return Util$SmartcutsMacros.shortcutWithIndex2(words, (function (param, index) {
                if ((param[0] + param[1].length | 0) >= offset) {
                  return index;
                }
                
              }));
}

var SemanticsNthWord = {
  indexOfWordAtOffset: indexOfWordAtOffset
};

exports.$$Text = $$Text;
exports.SemanticsPrefixSuffix = SemanticsPrefixSuffix;
exports.SemanticsNthWord = SemanticsNthWord;
/* Webapi__Dom__Node Not a pure module */
